import { useState } from 'react'

type BrandLogoProps = {
  compact?: boolean
  subtitle?: string
}

export function BrandLogo({ compact = false, subtitle = 'Sanskar Gurukulam' }: BrandLogoProps) {
  const [logoFailed, setLogoFailed] = useState(false)

  return <span className={`brand-logo ${compact ? 'brand-logo-compact' : ''}`}>
    {!logoFailed && <img src="/brand/logo.png" alt="" onError={() => setLogoFailed(true)} />}
    {logoFailed && <span className="brand-logo-fallback" aria-hidden="true">SGS</span>}
    <span className="brand-logo-text">
      <strong>SGS Fee Portal</strong>
      {!compact && <small>{subtitle}</small>}
    </span>
  </span>
}

export function PageBrandHeader({
  title,
  eyebrow,
  helper,
  hideLogo = false,
}: {
  title: string
  eyebrow: string
  helper?: string
  hideLogo?: boolean
}) {
  return <header className={`records-header page-brand-header ${hideLogo ? 'page-brand-header-textonly' : ''}`}>
    {!hideLogo && <BrandLogo compact />}
    <div className="page-brand-header-content">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      {helper && <p className="muted">{helper}</p>}
    </div>
  </header>
}
